import store from "~/js/store/store";
export default class ImportantModal {
  constructor() {
    this.setup();
  }
  setup() {
    const importantNotice = document.querySelector(".js-important-notice");
    if (importantNotice) {
      importantNotice.addEventListener("click", (event) => {
        event.preventDefault();
        store.dispatch("openModal", {
          name: "important-notice"
        });
      });
    }
  }

  /*openModal(name) {
    this.body.classList.add(name + "-modalopen");
    this.body.classList.add("modal-open");
    this.createModalContents();
    this.updateModal(name);
    Common.toggleTabIndexActivate(false);
    // tab対応
    gsap.to(window, {
      duration: 0,
      scrollTo: {
        y: ".l-header"
      }
    });
  }

  closeModal(name) {
    this.body.classList.remove(name + "-modalopen");
    this.body.classList.remove("modal-open");
    const container = document.querySelector(".js-modal-contents");
    Common.toggleTabIndexActivate(true);
    this.clearContents(container);
  }*/
}
